module.exports = __webpack_public_path__ + "static/media/user.b6fd4a57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/user.svg
// module id = 863
// module chunks = 0